// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-content-orders > div {
  max-width: 1920px !important;
}

.OrderSearchView__table__eRCXs {
  background: #fff;
}
.OrderSearchView__table__eRCXs .ant-table-row {
  cursor: pointer;
}
.OrderSearchView__table__eRCXs .selected-row {
  background-color: #f2f2f2;
}
@media (min-width: 992px) {
  .OrderSearchView__table__eRCXs .collapsible {
    display: none;
  }
}
@media (min-width: 1920px) {
  .OrderSearchView__table__eRCXs .collapsible {
    display: table-cell;
  }
}`, "",{"version":3,"sources":["webpack://./src/apps/orders/OrderSearchView.scss"],"names":[],"mappings":"AACE;EACE,4BAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AAII;EACE,eAAA;AAFN;AAKI;EACE,yBAAA;AAHN;AAMI;EACE;IACE,aAAA;EAJN;AACF;AAOI;EACE;IACE,mBAAA;EALN;AACF","sourcesContent":[":global {\n  .layout-content-orders > div {\n    max-width: 1920px !important;\n  }\n}\n\n.table {\n  background: #fff;\n\n  :global {\n    .ant-table-row {\n      cursor: pointer;\n    }\n\n    .selected-row {\n      background-color: #f2f2f2;\n    }\n    // Just on desktop screens\n    @media (min-width: 992px) {\n      .collapsible {\n        display: none;\n      }\n    }\n\n    @media (min-width: 1920px) {\n      .collapsible {\n        display: table-cell;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `OrderSearchView__table__eRCXs`
};
export default ___CSS_LOADER_EXPORT___;
